import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { ExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const EXPERIENCE_NAME = 'jiraVersionApproversCard';
const ANALYTICS_SOURCE = 'versionDetails';

export const VersionApproversCardExperienceStart = (): React.JSX.Element => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={`${Date.now()}`}
			experience={EXPERIENCE_NAME}
			analyticsSource={ANALYTICS_SOURCE}
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const VersionApproversCardExperienceSuccess = (): React.JSX.Element => (
	<ExperienceSuccess experience={EXPERIENCE_NAME} />
);

export const useVersionApproversCardExperienceFail = () =>
	useExperienceFail({
		experience: EXPERIENCE_NAME,
	});
